import { createBrowserHistory } from 'history';
import { UTM_KEYS, getStoredUtms } from './components/trashie/utils/url';

const history = createBrowserHistory();

/**
 * Injects stored UTM params into a navigation target.
 * Reads from sessionStorage (set once on landing by UtmProvider),
 * so UTMs survive page reloads and full-page redirects.
 */
function injectUtms(to) {
  const utms = getStoredUtms();
  if (!Object.keys(utms).length) return to;

  if (typeof to === 'string') {
    const url = new URL(to, window.location.origin);
    UTM_KEYS.forEach((key) => {
      if (utms[key] && !url.searchParams.has(key)) {
        url.searchParams.set(key, utms[key]);
      }
    });
    return url.pathname + url.search + url.hash;
  }

  if (typeof to === 'object' && to !== null) {
    const search = new URLSearchParams(to.search || '');
    UTM_KEYS.forEach((key) => {
      if (utms[key] && !search.has(key)) {
        search.set(key, utms[key]);
      }
    });
    const qs = search.toString();
    return { ...to, search: qs ? `?${qs}` : '' };
  }

  return to;
}

const originalPush = history.push.bind(history);
const originalReplace = history.replace.bind(history);

history.push = (to, state) => originalPush(injectUtms(to), state);
history.replace = (to, state) => originalReplace(injectUtms(to), state);

export default history;
